import { getDateWithSpecificFormat } from '../../../../data-transform';
import { getStatusDescriptionFromStatusValue, getOrderTypeText } from '../../../../../utils/utility';

export default function indirectCustomerOrderListColumnsSpecification(config) {
    if (!config.data) return null;

    const { orderList = [], customerType, userType, fromMyDashboard = false } = config.data;

    let result = {};
    let tableData = [];

    orderList.forEach((order, index) => {
        let row = [];
        const rowId = order.orderId;

        config.columns.forEach(column => {
            const columnId = column.id;
            const displayAsIs = column.data.displayInBodyAsIs;
            const columnDataType = column.data.displayInBodyAs;
            const highlightColumn = column.data.highlightBodyText;

            let columnValue = null;
            let linkDestination = null;
            let isDisabled = false;

            if (columnDataType === "link") {
                if (columnId === "orderId" && order.orderId) {
                    columnValue = order.orderId;
                    linkDestination = '/my-customer-orders/order-detail/' + order.orderId;
                }
            }
            else if (columnDataType === "string") {
                if (columnId === "vendorOrderId") {
                    columnValue = order.vendorOrderId || "";
                }
                else if (columnId === "orderType") {
                    columnValue = getOrderTypeText(order.orderType) || "";
                }
                else if (columnId === "status") {
                    let statusForCustomer;
                    if (order.status === 'ORDER_SENT' || order.status === 'ORDER_RECEIVED') {
                        statusForCustomer = 'ORDER_SUBMITTED';
                    }
                    columnValue = order.status ? getStatusDescriptionFromStatusValue(statusForCustomer || order.status) : "";
                }
                else if (columnId === "totalAssets") {
                    columnValue = (order.qtyOfAssetsRequested && order.qtyOfAssetsRequested) || "";
                }
                else if (columnId === "quotedNetValue") {
                    columnValue = order.quotedNetValue || "";
                }
                else if (columnId === "reportingStatus") {
                    columnValue = order.reportingStatus ? getStatusDescriptionFromStatusValue(order.reportingStatus) : "";
                }
                else if (columnId === "paymentStatus") {
                    columnValue = columnValue = order.paymentStatus ? getStatusDescriptionFromStatusValue(order.paymentStatus) : "";
                }
                else if (column.id === "currencyCode") {
                    columnValue = order.currencyCode || "";
                }
                else if (column.id === "collectionDate") {
                    columnValue = getDateWithSpecificFormat(order.collectionDate) || "";
                    if(order.orderType === '2') {
                        isDisabled = true;
                    }
                }
                else if (column.id === "assetsReceiptDate") {
                    columnValue = getDateWithSpecificFormat(order.assetsReceiptDate) || "";
                }
            }

            row.push({
                [columnId]: {
                    id: rowId,
                    columnId: columnId,
                    type: columnDataType,
                    value: columnValue,
                    width: column.width,
                    displayAsIs: displayAsIs,
                    showInMobileViewAs: column.showInMobileViewAs,
                    highlightColumn: highlightColumn,
                    disabled: isDisabled,
                    linkDestination: linkDestination,
                    clickHandler: (columnDataType !== "string" && config.bodyButtonsHandler) ? event => config.bodyButtonsHandler(event, columnId, index) : null
                }
            });
        });

        tableData.push({
            id: rowId,
            data: row
        });
    })

    result['columns'] = config.columns || [];
    result['data'] = tableData || [];
    return result;
}
